<!--
  * NFTokenAcceptOffer Transaction Details
  *
  * Copyright (c) 2022 Dev Null Productions - All Rights Reserved
  -->
<template>
  <XRPTxContainer :tx="tx">
    <div class="offer">
      Offer: {{offer | ellipsis(10)}}
    </div>
  </XRPTxContainer>
</template>

<script>
import XRPTxContainer from './Container'
import Meta           from './meta'

export default {
  name   : 'NFTokenAcceptOffer',

  mixins : [Meta],

  components : {
    XRPTxContainer
  },

  computed : {
    offer : function(){
      return this.tx_obj['NFTokenSellOffer'] ||
             this.tx_obj['NFTokenBuyOffer'];
    }
  }
}
</script>

<style scoped>
.offer{
  flex-basis: 14%;
  font-size: 0.8rem;

  display: flex;
  align-items: center;
  justify-content: flex-end;
}

#main_layout.sm .offer,
#main_layout.xs .offer{
  flex-basis: 78%;
}
</style>
